import ScrollOut from "scroll-out";

const griglia = $(".partnersgrid");

ScrollOut({
    targets: ".partnersgrid__img",
    threshold: 0.9,
    onShown: function() {
        var el = $(".partnersgrid__img"),
            i = 0,
            f = function() {
                $(el[i++]).addClass("animated fadeInUp");
                if (i < el.length) setTimeout(f, 200);
            };
        f();
    }
});